import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

const usePhysicianTeam = physicianUserId => {
  const dispatch = useDispatch();
  const { load } = dispatch.physicianTeam;
  const isLoading = useSelector(({ loading }) => loading.effects.physicianTeam.load);
  const data = useSelector(state => state.physicianTeam);

  useEffect(() => {
    if (physicianUserId) {
      load({ physicianUserId });
    }
  }, [physicianUserId]);

  return {
    teamUsersIds: data[physicianUserId]?.teamUsersIds || null,
    isLoading,
  };
};

export default usePhysicianTeam;
